module.exports = __webpack_public_path__ + "static/media/payment_status_requested.5e8fe2d4.svg";